import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPost } from 'api-service';
import { toast } from 'lib';
import translation from 'translation';
import { addDepartment } from 'store/department/department.actions';
import { errorHandler } from '../errorHandler';
import { userAdapter } from './user.adapters';

const { t } = translation;

export const fetchUsers = createAsyncThunk(
  'userReducer/fetchUsers',
  async (params = {}, thunkAPI) => {
    const { settingsReducer } = thunkAPI.getState();
    const { isAdmin, ...restParams } = params;
    try {
      const response = await apiGet(
        isAdmin ? '/user/monitoring/users' : '/user',
        {
          page: 1,
          per_page:
            settingsReducer?.filters?.public?.pageContentCountSlider
              ?.selectedValue,
          ...restParams,
        }
      );
      return {
        users: response.data?.result?.data,
        total: response.data?.result?.meta?.total,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addNewUser = createAsyncThunk(
  'userReducer/addNewUser',
  async (params = {}, thunkAPI) => {
    try {
      if (params.shouldAssignToDepartment) {
        const response = await thunkAPI.dispatch(
          addDepartment({
            department_name: `${params.name} ${params.last_name} (${params.department_name})`,
            parent_id: params.department_id,
          })
        );
        params.department_id = response?.payload?.department_id;
      }

      const response = await apiPost('/user', params);

      toast({
        title: t('common:successOperation'),
        description: t('users:success.addNewUser.description'),
      });
      return response.data?.result?.data;
    } catch (error) {
      errorHandler({
        error,
        message: { description: t('users:error.addNewUser.description') },
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const editUser = createAsyncThunk(
  'userReducer/editUser',
  async ({ userId, params }, thunkAPI) => {
    try {
      const response = await apiPost(`/user/${userId}`, {
        _method: 'put',
        ...params,
      });
      toast({
        title: t('common:successOperation'),
        description: t('users:success.editUser.description'),
      });
      return response.data?.result?.data;
    } catch (error) {
      errorHandler({
        error,
        message: { description: t('users:error.editUser.description') },
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchUserById = createAsyncThunk(
  'userReducer/fetchUserById',
  async ({ userId }, thunkAPI) => {
    try {
      const response = await apiGet(`/user/${userId}`);

      return userAdapter(response.data?.result);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchUserByToken = createAsyncThunk(
  'userReducer/fetchUserByToken',
  async (token, thunkAPI) => {
    try {
      const response = await apiGet('/user/user', undefined, {
        Authorization: token,
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
